import React, { useEffect, useState } from "react";
import { Button, Popover, Box } from "@material-ui/core";
import { ReactComponent as IHIIcon } from "../../../../images/icon-profile-fill.svg";
import { ReactComponent as PopoverButtonUp } from "../../../../images/PopoverButtonUp.svg";
import { ReactComponent as PopoverButtonDown } from "../../../../images/PopoverButtonDown.svg";
import styles from './PatientIhiDetails.module.scss';
import { IndividualHealthcareIdentifier } from "../../../../services/healthcareidentifier/models/IndividualHealthcareIdentifier";
import { RenderIf } from "../../render-if/RenderIf";
import { IhiStatusType } from "../../../../services/healthcareidentifier/models/IhiStatusType";
import { IhiRecordStatusType } from "../../../../services/healthcareidentifier/models/IhiRecordStatusType";
import { LinkButton } from "../..";
import { Patient } from "../../../../services/medicationmanagement/patientApi/models/Patient";
import { SearchIcon } from "@communicare/medications/Components/Icons";


export interface IhiDetailsProps {
    ihi: IndividualHealthcareIdentifier,
    resident: Patient;
}


export const PatientIhiDetails = (props: IhiDetailsProps) => {

    let { ihi } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popoverWidth, setPopoverWidth] = React.useState(0);
    const handleClick = (event: any) => {
        setPopoverWidth(event.currentTarget?.offsetWidth);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRetryIhi = () => {
        window.location.reload();
    };
    

    const open = Boolean(anchorEl);
    const id = open ? 'ihi-popover' : undefined;
    const buttonEndIcon = open ? <PopoverButtonUp /> : <PopoverButtonDown />;
    
    

    return (
        <React.Fragment>

            <Button id="ihiPopoverButton" className={styles.ihiButton} aria-describedby={id} variant={"outlined"} startIcon={<IHIIcon />} onClick={handleClick} endIcon={buttonEndIcon}>
        
                <RenderIf if={ihi.recordStatus != "" || ihi.status != ""}>
                    <div>
                        Resident IHI details 
                        {ihi.recordStatus.toLowerCase() != IhiRecordStatusType.Verified.toLowerCase() && 
                            <span className={styles.ihiRecordStatusWarning}>&nbsp;–  Check details with facility</span>
                        }
                        {ihi.status.toLowerCase() === IhiStatusType.Retired.toLowerCase() &&
                            <span className={styles.ihiRecordStatusWarning}>&nbsp;– {ihi.status}</span>
                        }
                    </div>
                </RenderIf>
                <RenderIf if={ihi.recordStatus == "" && ihi.status == ""}>
                    <div>
                        Resident IHI details <span className={styles.ihiRecordStatusWarning}>&nbsp;– Unable to validate IHI</span>
                    </div>
                </RenderIf>
            </Button>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                PaperProps={{
                    style: { minWidth: popoverWidth }
                }}
            >
                <Box id="popoverBox" className={styles.popoverContainer}>
                    <Box className={styles.popoverRow}>
                        <span className={styles.label}>IHI number</span> {" "} <span className={styles.data}>{ihi.number}</span>
                        <RenderIf if={ihi.status.toLowerCase() == IhiStatusType.None.toLowerCase()}>
                            <span className={styles.data}> (Record NOT found)</span>
                        </RenderIf>
                    </Box>
                    <Box className={styles.popoverRow}>
                        <span className={styles.label}>IHI number status</span> {" "} 
                        <RenderIf if={ihi.status.toLowerCase() != IhiStatusType.None.toLowerCase() && ihi.status.toLowerCase() != IhiStatusType.Retired.toLowerCase()}>
                            <span className={styles.data}>   {ihi.status}</span>
                        </RenderIf>
                        <RenderIf if={ihi.status.toLowerCase() === IhiStatusType.Retired.toLowerCase()}>
                            <span className={styles.ihiRecordStatusWarning}>   {ihi.status}</span>
                        </RenderIf>
                    </Box>
                    <Box className={styles.popoverRow}>
                        <span className={styles.label}>IHI record status</span> {" "} 
                        <RenderIf if={ihi.status != "" && ihi.status.toLowerCase() != IhiStatusType.None.toLowerCase()}>
                            <span className={styles.data}>   {ihi.recordStatus}</span>
                        </RenderIf>
                        <RenderIf if={ihi.status != "" && ihi.recordStatus.toLowerCase() != IhiRecordStatusType.Verified.toLowerCase()}>
                            <span className={styles.ihiRecordStatusWarning}> - &nbsp; Check status with facility</span>
                        </RenderIf>
                    </Box>
                    <RenderIf if={ihi.status == ""}>
                        <div>
                        <Box className={styles.popoverRow}>
                            <span className={styles.ihiRecordStatusWarning}> Unable to validate IHI</span>                                      
                        </Box>
                        <Box className={styles.popoverRow}>
                            <Button className={styles.ihiRetryButton} variant={"outlined"} onClick={handleRetryIhi} >
                                Retry validation
                            </Button>                                         
                        </Box>
                        </div>
                    </RenderIf>
                    

                </Box>
            </Popover>
        </React.Fragment>
    );
};
